module.exports = __webpack_public_path__ + "img/revisao2.ff12e30e.jpg";